<script>
    import { faCalendar } from "@fortawesome/free-solid-svg-icons";
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../ui/Button.svelte";
    import DateRangePicker from "./DateRangePicker.svelte";

    export let start;
    export let end;
    export let minimumDuration;
    export let blocked;
    export let id;
    export let disabled = false;
    
    let dateFormat = {year: 'numeric', month: '2-digit', day: '2-digit'};
    let temp_start = start;
    let temp_end = end;
    let valid = true;
    let open = false;

    const dispatch = createEventDispatcher();

    function confirm() {
        start = temp_start;
        end = temp_end;
        dispatch("confirm");
        open = false;
    }

    function cancel() {
        open = false;
    }
</script>

<Button {disabled} type="button" on:click={() => {open = true}}>
    <Fa
        icon={faCalendar}
        slot="icon"
    />
    {#if start && end}
        {start.toLocaleDateString('de-DE', dateFormat)} - {end.toLocaleDateString('de-DE', dateFormat)}
    {:else}
        Zeitraum wählen
    {/if}
</Button>

<Dialog class="dialog" open={open} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Zeitraum wählen</DialogTitle>
        <DateRangePicker bind:blocked bind:id bind:start={temp_start} bind:end={temp_end} bind:valid={valid} minDuration={minimumDuration}/>
        <div class="dialog-options">
            <Button on:click={cancel}>
                Abbrechen
            </Button>
            <Button intent="primary" on:click={confirm} disabled={!valid}>
                Bestätigen
            </Button>
        </div>
    </div>
</Dialog>
